module.exports = __webpack_public_path__ + "static/media/25.b40cb624.jpg";